import React, { useState } from 'react';
import './Gallery.css';
import { CATEGORY_DATA } from './CategoryDetailView';

const STATIC_PHOTOS = [
  // Wedding
  { id: 101, url: '/images/Website%20Photos/10112c165559d9253cf53fe7a626b2bb.jpg', label: 'Wedding Rituals', category: 'Wedding', span: 'tall' },
  { id: 102, url: '/images/Website%20Photos/14bddc301f93aee5b77cc8ba1c413ccf.jpg', label: 'Bridal Portrait', category: 'Wedding', span: 'normal' },
  { id: 103, url: '/images/Website%20Photos/2eb3cf6859dda8b0f434ef3fc1d8dfa4.jpg', label: 'Bride & Groom', category: 'Wedding', span: 'wide' },
  { id: 104, url: '/images/Website%20Photos/33b2ff9463238233e4ab96534fcb3cd1.jpg', label: 'Ceremony', category: 'Wedding', span: 'normal' },
  { id: 105, url: '/images/Website%20Photos/37e713557a5f8e45758d8bb5c0669dbe.jpg', label: 'Candid Moments', category: 'Wedding', span: 'tall' },
  { id: 106, url: '/images/Website%20Photos/7a542bbce7ce133ca7ff2a8bd6aa8dd5.jpg', label: 'Wedding Decor', category: 'Wedding', span: 'normal' },

  // Interior
  { id: 901, url: '/images/Interior%20Video/DSC03448.jpg', label: 'Living Space', category: 'Interior', span: 'wide' },
  { id: 902, url: '/images/Interior%20Video/DSC03483%20copy.jpg', label: 'Decor Elements', category: 'Interior', span: 'normal' },
  { id: 903, url: '/images/Interior%20Video/DSC03543%20copy.jpg', label: 'Architecture', category: 'Interior', span: 'tall' },
  { id: 904, url: '/images/Interior%20Video/DSC03584%20copy%20(2).jpg', label: 'Bedroom Design', category: 'Interior', span: 'normal' },
  { id: 905, url: '/images/Interior%20Video/DSC03641.jpg', label: 'Modern Setup', category: 'Interior', span: 'normal' },
  { id: 906, url: '/images/Interior%20Video/DSC03653.JPG', label: 'Wada Vibes', category: 'Interior', span: 'wide' },
  { id: 951, url: '/images/Interior%20Video/DSC03681.jpg', label: 'Interior Photo', category: 'Interior', span: 'tall' },
  { id: 952, url: '/images/Interior%20Video/Nikhil_7568.jpg', label: 'Interior Photo', category: 'Interior', span: 'normal' },
  { id: 953, url: '/images/Interior%20Video/Nikhil_7573%20HDR%20Merge.jpg', label: 'Interior Photo', category: 'Interior', span: 'wide' },
  { id: 954, url: '/images/Interior%20Video/Nikhil_7576.jpg', label: 'Interior Photo', category: 'Interior', span: 'normal' },

  // Industrial
  { id: 401, url: '/images/Website%20first%20page%20Business/DSC_0001.jpg', label: 'Industrial Photo 1', category: 'Industrial', span: 'tall' },
  { id: 402, url: '/images/Website%20first%20page%20Business/DSC_0053.jpg', label: 'Industrial Photo 2', category: 'Industrial', span: 'normal' },
  { id: 403, url: '/images/Website%20first%20page%20Business/DSC_0077.jpg', label: 'Industrial Photo 3', category: 'Industrial', span: 'wide' },
  { id: 404, url: '/images/Website%20first%20page%20Business/DSC_0163.jpg', label: 'Industrial Photo 4', category: 'Industrial', span: 'normal' },
  { id: 405, url: '/images/Website%20first%20page%20Business/IMG_2317.JPG', label: 'Industrial Photo 5', category: 'Industrial', span: 'tall' },
  { id: 406, url: '/images/Website%20first%20page%20Business/IMG_2329.JPG', label: 'Industrial Photo 6', category: 'Industrial', span: 'normal' },
  { id: 407, url: '/images/Website%20first%20page%20Business/IMG_2332.JPG', label: 'Industrial Photo 7', category: 'Industrial', span: 'wide' },
  { id: 408, url: '/images/Website%20first%20page%20Business/IMG_2370.JPG', label: 'Industrial Photo 8', category: 'Industrial', span: 'normal' },
  { id: 409, url: '/images/Website%20first%20page%20Business/IMG_2373.JPG', label: 'Industrial Photo 9', category: 'Industrial', span: 'tall' },
  { id: 410, url: '/images/Website%20first%20page%20Business/IMG_2399.JPG', label: 'Industrial Photo 10', category: 'Industrial', span: 'normal' },
  { id: 411, url: '/images/Website%20first%20page%20Business/IMG_2445.JPG', label: 'Industrial Photo 11', category: 'Industrial', span: 'wide' },
  { id: 412, url: '/images/Website%20first%20page%20Business/IMG_2464.JPG', label: 'Industrial Photo 12', category: 'Industrial', span: 'normal' },
  { id: 413, url: '/images/Website%20first%20page%20Business/IMG_2488.JPG', label: 'Industrial Photo 13', category: 'Industrial', span: 'tall' },
  { id: 414, url: '/images/Website%20first%20page%20Business/IMG_2506.JPG', label: 'Industrial Photo 14', category: 'Industrial', span: 'normal' },
  { id: 415, url: '/images/Website%20first%20page%20Business/IMG_2549.JPG', label: 'Industrial Photo 15', category: 'Industrial', span: 'wide' },
  { id: 416, url: '/images/Website%20first%20page%20Business/IMG_2565.JPG', label: 'Industrial Photo 16', category: 'Industrial', span: 'normal' },
  { id: 417, url: '/images/Website%20first%20page%20Business/NIK03795.JPG', label: 'Industrial Photo 17', category: 'Industrial', span: 'tall' },
  { id: 418, url: '/images/Website%20first%20page%20Business/NIK03894.JPG', label: 'Industrial Photo 18', category: 'Industrial', span: 'normal' },
  { id: 419, url: '/images/Website%20first%20page%20Business/Nikhil_03803.jpg', label: 'Industrial Photo 19', category: 'Industrial', span: 'wide' },
  { id: 420, url: '/images/Website%20first%20page%20Business/Nikhil_03813.jpg', label: 'Industrial Photo 20', category: 'Industrial', span: 'normal' },

  // Corporate
  { id: 501, url: '/images/Website%20first%20page%20Business/IMG_5275.JPG', label: 'Corporate Photo 1', category: 'Corporate', span: 'tall' },
  { id: 502, url: '/images/Website%20first%20page%20Business/IMG_5280.JPG', label: 'Corporate Photo 2', category: 'Corporate', span: 'normal' },
  { id: 503, url: '/images/Website%20first%20page%20Business/IMG_5298.JPG', label: 'Corporate Photo 3', category: 'Corporate', span: 'wide' },
  { id: 504, url: '/images/Website%20first%20page%20Business/_NIK3782.JPG', label: 'Corporate Photo 4', category: 'Corporate', span: 'normal' },
  { id: 505, url: '/images/Website%20first%20page%20Business/_NIK3793.JPG', label: 'Corporate Photo 5', category: 'Corporate', span: 'tall' },
  { id: 506, url: '/images/Website%20first%20page%20Business/_NIK3827.JPG', label: 'Corporate Photo 6', category: 'Corporate', span: 'normal' },
  { id: 507, url: '/images/Website%20first%20page%20Business/_NIK3909.JPG', label: 'Corporate Photo 7', category: 'Corporate', span: 'wide' },
  { id: 508, url: '/images/Website%20first%20page%20Business/_NIK3911.JPG', label: 'Corporate Photo 8', category: 'Corporate', span: 'normal' },
  { id: 509, url: '/images/Website%20first%20page%20Business/_NIK4008.JPG', label: 'Corporate Photo 9', category: 'Corporate', span: 'tall' },
  { id: 510, url: '/images/Website%20first%20page%20Business/_NIK4018.JPG', label: 'Corporate Photo 10', category: 'Corporate', span: 'normal' },

  // Sports
  { id: 601, url: '/images/Website%20first%20page%20Business/IMG_0205.JPG', label: 'Sports Photo 1', category: 'Sport', span: 'tall' },
  { id: 602, url: '/images/Website%20first%20page%20Business/IMG_1376.JPG', label: 'Sports Photo 2', category: 'Sport', span: 'normal' },
  { id: 603, url: '/images/Website%20first%20page%20Business/IMG_4048.JPG', label: 'Sports Photo 3', category: 'Sport', span: 'wide' },
  { id: 604, url: '/images/Website%20first%20page%20Business/IMG_4051.JPG', label: 'Sports Photo 4', category: 'Sport', span: 'normal' },
  { id: 605, url: '/images/Website%20first%20page%20Business/IMG_4060.JPG', label: 'Sports Photo 5', category: 'Sport', span: 'tall' },
  { id: 606, url: '/images/Website%20first%20page%20Business/IMG_4068.JPG', label: 'Sports Photo 6', category: 'Sport', span: 'normal' },
  { id: 607, url: '/images/Website%20first%20page%20Business/IMG_4103.JPG', label: 'Sports Photo 7', category: 'Sport', span: 'wide' },
  { id: 608, url: '/images/Website%20first%20page%20Business/IMG_9506.JPG', label: 'Sports Photo 8', category: 'Sport', span: 'normal' },

  // Wildlife
  { id: 701, url: '/images/Website%20first%20page%20Business/NIK_7081.JPG', label: 'Wildlife Photo 1', category: 'Wildlife', span: 'tall' },
  { id: 702, url: '/images/Website%20first%20page%20Business/NIK_7082.JPG', label: 'Wildlife Photo 2', category: 'Wildlife', span: 'normal' },
  { id: 703, url: '/images/Website%20first%20page%20Business/NIK_7635%20copy.jpg', label: 'Wildlife Photo 3', category: 'Wildlife', span: 'wide' },
  { id: 704, url: '/images/Website%20first%20page%20Business/NIK_7784.JPG', label: 'Wildlife Photo 4', category: 'Wildlife', span: 'normal' },
  { id: 705, url: '/images/Website%20first%20page%20Business/NIK_7788.JPG', label: 'Wildlife Photo 5', category: 'Wildlife', span: 'tall' },
  { id: 706, url: '/images/Website%20first%20page%20Business/NIK_7851%20copy.jpg', label: 'Wildlife Photo 6', category: 'Wildlife', span: 'normal' },
  { id: 707, url: '/images/Website%20first%20page%20Business/NIK_7912.JPG', label: 'Wildlife Photo 7', category: 'Wildlife', span: 'wide' },
  { id: 708, url: '/images/Website%20first%20page%20Business/NIK_8577%20copy.jpg', label: 'Wildlife Photo 8', category: 'Wildlife', span: 'normal' },

  // Product
  { id: 801, url: '/images/Website%20first%20page%20Business/_NIK2891%20copy%20copy.jpg', label: 'Product Photo 1', category: 'Product', span: 'tall' },
  { id: 802, url: '/images/Website%20first%20page%20Business/_NIK2893.jpg', label: 'Product Photo 2', category: 'Product', span: 'normal' },
  { id: 803, url: '/images/Website%20first%20page%20Business/_NIK2895.jpg', label: 'Product Photo 3', category: 'Product', span: 'wide' },
  { id: 804, url: '/images/Website%20first%20page%20Business/_NIK2897.jpg', label: 'Product Photo 4', category: 'Product', span: 'normal' },
  { id: 805, url: '/images/Website%20first%20page%20Business/_NIK2899.jpg', label: 'Product Photo 5', category: 'Product', span: 'tall' },
  { id: 806, url: '/images/Website%20first%20page%20Business/_NIK2900.jpg', label: 'Product Photo 6', category: 'Product', span: 'normal' },
  { id: 807, url: '/images/Website%20first%20page%20Business/_NIK2904.jpg', label: 'Product Photo 7', category: 'Product', span: 'wide' },
  { id: 808, url: '/images/Website%20first%20page%20Business/DSC_0460.JPG', label: 'Product Photo 8', category: 'Product', span: 'normal' },

  // Engagement
  { id: 301, url: '/images/Prewedding%20sample/Prewedding%201/NIK_2261.JPG', label: 'Engagement Photo 1', category: 'Engagement', span: 'tall' },
  { id: 302, url: '/images/Prewedding%20sample/Prewedding%201/NIK_2264.JPG', label: 'Engagement Photo 2', category: 'Engagement', span: 'normal' },
  { id: 303, url: '/images/Prewedding%20sample/Prewedding%201/NIK_2329.JPG', label: 'Engagement Photo 3', category: 'Engagement', span: 'wide' },
  { id: 304, url: '/images/Prewedding%20sample/Prewedding%201/NIK_2387.JPG', label: 'Engagement Photo 4', category: 'Engagement', span: 'normal' },
  { id: 305, url: '/images/Prewedding%20sample/Prewedding%201/NIK_2425.JPG', label: 'Engagement Photo 5', category: 'Engagement', span: 'tall' },
  { id: 306, url: '/images/Prewedding%20sample/Prewedding%201/NIK_3442.JPG', label: 'Engagement Photo 6', category: 'Engagement', span: 'normal' },
  { id: 307, url: '/images/Prewedding%20sample/Prewedding%201/NIK_3446.JPG', label: 'Engagement Photo 7', category: 'Engagement', span: 'wide' },
  { id: 308, url: '/images/Prewedding%20sample/Prewedding%201/NIK_3452.JPG', label: 'Engagement Photo 8', category: 'Engagement', span: 'normal' },
  { id: 309, url: '/images/Prewedding%20sample/Prewedding%201/NIK_3497.JPG', label: 'Engagement Photo 9', category: 'Engagement', span: 'tall' },
  { id: 310, url: '/images/Prewedding%20sample/Prewedding%201/NIK_3504.JPG', label: 'Engagement Photo 10', category: 'Engagement', span: 'normal' },
];

const SPAN_CLASSES = ['tall', 'normal', 'wide'];
const ALL_PHOTOS = [...STATIC_PHOTOS];
let globalId = 1000;
const existingUrls = new Set(ALL_PHOTOS.map(p => p.url));

Object.keys(CATEGORY_DATA).forEach(categoryKey => {
  const catName = categoryKey.charAt(0).toUpperCase() + categoryKey.slice(1);
  const images = CATEGORY_DATA[categoryKey].images;

  if (images && Array.isArray(images)) {
    images.forEach((url, idx) => {
      if (!existingUrls.has(url)) {
        ALL_PHOTOS.push({
          id: globalId++,
          url: url,
          label: `${catName} Photo ${idx + 1}`,
          category: catName,
          span: SPAN_CLASSES[idx % SPAN_CLASSES.length]
        });
        existingUrls.add(url);
      }
    });
  }
});

const FAMILY_CATS = ['Wedding', 'Engagement', 'Upanayan', 'Birthday', 'Portrait', 'Couple', 'Kids'];
const BUSINESS_CATS = ['Product', 'Industrial', 'Exterior', 'Corporate', 'Food', 'Interior', 'Fashion', 'Sport', 'Wildlife'];

const Gallery = ({ initialFilter = 'All' }) => {
  const [activeFilter, setActiveFilter] = useState(initialFilter);
  const [currentPage, setCurrentPage] = useState(1);
  const photosPerPage = 20;

  const handleFilterChange = (cat) => {
    setActiveFilter(cat);
    setCurrentPage(1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const filteredPhotos = activeFilter === 'All'
    ? ALL_PHOTOS
    : ALL_PHOTOS.filter(photo => photo.category === activeFilter);

  const totalPages = Math.ceil(filteredPhotos.length / photosPerPage);
  const startIndex = (currentPage - 1) * photosPerPage;
  const paginatedPhotos = filteredPhotos.slice(startIndex, startIndex + photosPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 400, behavior: 'smooth' });
  };

  return (
    <section id="gallery" className="gallery gallery--page">
      <div className="container">
        <div className="gallery__header">
          <div className="gallery__header-left">
            <div className="section-label">Portfolio</div>
            <h2 className="section-title">Moments Preserved Forever</h2>
          </div>
          <p className="gallery__subtitle">
            A glimpse into our world of captured emotions and timeless beauty across all our photography services.
          </p>
        </div>

        <div className="gallery__nav-container">
          <div className="gallery__nav-top">
            <button
              className={`gallery__nav-btn ${activeFilter === 'All' ? 'active' : ''}`}
              onClick={() => handleFilterChange('All')}
            >
              ALL
            </button>
          </div>

          <div className="gallery__nav-columns">
            <div className="gallery__nav-left">
              {FAMILY_CATS.map(cat => (
                <button
                  key={cat}
                  className={`gallery__nav-btn ${activeFilter === cat ? 'active' : ''}`}
                  onClick={() => handleFilterChange(cat)}
                >
                  {cat.toUpperCase()}
                </button>
              ))}
            </div>

            <div className="gallery__nav-right">
              {BUSINESS_CATS.map(cat => (
                <button
                  key={cat}
                  className={`gallery__nav-btn ${activeFilter === cat ? 'active' : ''}`}
                  onClick={() => handleFilterChange(cat)}
                >
                  {cat.toUpperCase()}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="gallery__grid">
          {paginatedPhotos.map((photo) => (
            <div
              key={photo.id}
              className={`gallery__item gallery__item--${photo.span}`}
            >
              <img src={photo.url} alt={photo.label} loading="lazy" />
              <div className="gallery__overlay">
                <span className="gallery__cat">{photo.category}</span>
                <h3 className="gallery__label">{photo.label}</h3>
              </div>
            </div>
          ))}
        </div>

        {totalPages > 1 && (
          <div className="gallery__pagination">
            <button
              className="pagination-arrow"
              onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
            >
              &laquo;
            </button>

            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i + 1}
                className={`pagination-number ${currentPage === i + 1 ? 'active' : ''}`}
                onClick={() => handlePageChange(i + 1)}
              >
                {i + 1}
              </button>
            ))}

            <button
              className="pagination-arrow"
              onClick={() => handlePageChange(Math.min(totalPages, currentPage + 1))}
              disabled={currentPage === totalPages}
            >
              &raquo;
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Gallery;